import i18n from 'src/i18n'
import {
  MentionEmptyText,
  MentionImage,
  MentionItem,
  MentionItemWrapper,
  MentionReference,
  MentionText,
  TextWrapper
} from './mentionListItem.styles'
import { MentionListItemProps } from './mentionListItem.types'

const MentionListItem = ({
  image,
  label,
  reference,
  isSelected,
  noResults,
  onClick
}: MentionListItemProps) => {
  if (noResults) {
    return (
      <MentionItem>
        <MentionEmptyText className="_d-flex _align-items-center _justify-content-center _text-gray-900 _line-height _font-14">
          {i18n.t('comments.mentions.empty_state')}
        </MentionEmptyText>
      </MentionItem>
    )
  }

  return (
    <MentionItem
      className={'_w-full _px-5 _border-0 _cursor-pointer'}
      $isSelected={isSelected}
      onClick={onClick}
    >
      <MentionItemWrapper className="_d-flex _align-items-center _border-bottom _border-gray-200">
        <MentionImage src={image} alt={label} className="_mr-4" />

        <TextWrapper className="_d-flex _align-items-start _flex-column _text-left">
          <MentionText className="_text-gray-900 _line-height _font-14">{label}</MentionText>
          {reference && (
            <MentionReference className="_d-block _w-full _text-1 _text-gray-500 _pt-1 _overflow-hidden">
              @{reference}
            </MentionReference>
          )}
        </TextWrapper>
      </MentionItemWrapper>
    </MentionItem>
  )
}

export default MentionListItem
